import React, { useEffect, useState } from 'react'
import './loginuser.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useAuthContext } from '../../Hooks/useAuthContext'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'wc-toast'
import axios from 'axios'
import Navigation from '../../Component/Navigation/Navigation'

function LoginUser() {
  const [data, setData]               = useState([])
  const [disabled, setDisabled]       = useState(true)
  const { user, dispatch }            = useAuthContext()
  const [btnState, setBtnState]       = useState('Sign in')
  const [seePassword, setSeePassword] = useState(false)
  const navigate                      = useNavigate()

  useEffect(() => {
    console.log(data)
    if (data.email && data.password) setDisabled(false)
    else setDisabled(true)
  }, [data])

  const handleSubmit = (e) => {
    e.preventDefault()
    setBtnState('Processing...')
    console.log('in handle submit')
    console.log(process.env.REACT_APP_API_URL)
    axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/user/login-user`,
      data,
      { headers: { 'Content-Type': 'application/json' } }
    ).then(response => {
      setData({ email: '', password: '' })
      toast.success('You have successfully signed in')
      console.log('in good response')
      localStorage.setItem('user', JSON.stringify(response.data))
      dispatch({ type: 'LOGIN', payload: response.data })
      setBtnState('Sign In')
      navigate('/dashboard')
    }).catch(error => {
      console.log('in bad response')
      setBtnState('Sign in')
      toast.error(error.response.data.error)
    })
  }

  return (
    <div className="auth-page">
      <Navigation />

      <div className="auth-split">

        {/* ── Left — image panel ─────────────────────────── */}
        <div className="auth-split__image">
          <div className="auth-split__image-body">
            <span className="auth-split__label">JFE Bank — Secure Access</span>
            <h2 className="auth-split__title">
              Welcome <em>back</em>
            </h2>
            <p className="auth-split__sub">
              Sign in to access your accounts, manage transfers,
              and monitor your finances.
            </p>
            <ul className="auth-trust">
              <li>256-bit SSL encryption</li>
              <li>Two-factor authentication</li>
              <li>24/7 fraud monitoring</li>
            </ul>
          </div>
        </div>

        {/* ── Right — form panel ─────────────────────────── */}
        <div className="auth-split__form">
          <div className="auth-card">
            <div className="auth-card__bar" />

            <div className="auth-card__head">
              <h2>Login to Account</h2>
              <p>Enter your credentials to access your account.</p>
            </div>

            <form className="auth-card__body" onSubmit={handleSubmit}>

              <div className="auth-field">
                <label>Email / Account Number</label>
                <input
                  type="text"
                  placeholder="Enter your email or Account Number"
                  value={data?.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  required
                />
              </div>

              <div className="auth-field">
                <label>Password</label>
                <div className="auth-field__pw">
                  <input
                    type={seePassword ? 'text' : 'password'}
                    placeholder="Enter Password"
                    value={data?.password}
                    onChange={(e) => setData({ ...data, password: e.target.value })}
                    required
                  />
                  <button
                    type="button"
                    className="auth-field__pw-toggle"
                    onClick={() => { console.log(seePassword ? 'Eye Slash' : 'Eye'); setSeePassword(!seePassword) }}
                  >
                    {seePassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="auth-btn auth-btn--navy"
                disabled={disabled}
              >
                {btnState}
              </button>

              <div className="auth-divider" />

              <Link to="/forgot-password" style={{ textDecoration: 'none' }}>
                <button type="button" className="auth-btn auth-btn--outline">
                  Forgot Password
                </button>
              </Link>

            </form>
          </div>
        </div>

      </div>
    </div>
  )
}

export default LoginUser